import React from "react";

// For Table Checkbox
function ColumnRow({ id, name, handleChange, checked, value, disabled }) {
  return (
    <td className="px-6 py-4 whitespace-nowrap text-base text-gray-500">
      <input
        type="checkbox"
        name={name}
        id={id}
        value={value}
        disabled={disabled}
        checked={checked}
        onClick={(e) => handleChange(e)}
        aria-describedby="comments-description"
        className={`focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded ${
          disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
        }`}
      />
    </td>
  );
}

export default ColumnRow;
